<template>
  <nav>
    <div v-if="surveyOverview">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p class="text-subtitle-1 no-break font-weight-bold" v-html="question.question"></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters class="text-center go-to-answers-row">
        <v-col cols="12">
          <p class="mb-5">
            {{ $t("surveyGoToIndividualstab") }}
          </p>
          <v-btn
            data-testid="go-to-answers-button"
            type="submit"
            color="accent"
            min-width="260"
            dark
            elevation="0"
            class="rounded-l text-none px-4 mb-5 white--text"
            @click="redirectToIndividualAnswers"
          >
            {{ $t("goToAnswers") }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="user">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p
            class="text-subtitle-1 no-break font-weight-bold"
            v-html="question.question"
          ></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
        data-testid="survey-1"
        class="mt-5 mb-3"
      >
        <v-col cols="12" sm="12" :md="pdf ? 9 : 7">
          <v-textarea
            dense
            outlined
            readonly
            :value="user[question.qid].answer.answer"
            rows="4"
            cols="50"
          ></v-textarea>
          <div class="survey-attachment-icon-link">
            <v-icon data-testid="attachment-icon" class="d-inline-flex survey-attachment-icon"> mdi-paperclip </v-icon>
            <a
              class="greytext--text text-caption d-inline-flex survey-attachment-link"
              target="_blank"
              :href="user[question.qid].answer.attachment_url"
            >
              <v-clamp autoresize :max-lines="1" class="text-caption align-self-center">
                {{ user[question.qid].answer.title }}
              </v-clamp>
            </a>
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-textarea
        dense
        outlined
        disabled
        class="survey-open-textarea rounded-lg pa-0 ma-0 mt-3 text-body-2 mx-auto"
        :placeholder="$t('surveyTextareaParticipantPlaceholder')"
        data-testid="open-textarea"
        :hide-details="true"
      />
      <v-icon data-testid="attachment-icon"> mdi-paperclip </v-icon>
    </div>
  </nav>
</template>
<script>
import { repeatedMethodsMixin } from "../../../mixins/repeatedMethodsMixin";
import VClamp from "vue-clamp";

export default {
  components: {
    VClamp
  },
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    surveyOverview: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
    pdf: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [repeatedMethodsMixin],
 
  methods: {
    redirectToIndividualAnswers(){
      this.$router.push({name: 'SurveyIndividuals', params: {id: this.$route.params.id, surveyId: this.$route.params.surveyId}})
    },
  }
};
</script>